import type { Map } from 'mapbox-gl'

import { LAYERS } from './config/Layers'

export function removeLayerFrom (map: Map | null | undefined, id: string) {
  try {
    if (map?.getLayer(id)) {
      map?.removeLayer(id)
    }
    if (map?.getSource(id)) {
      map?.removeSource(id)
    }
  } catch (error) {
    console.warn(`Unable to remove layer [${id}]: ${error}`)
  }
}

export function removeDayNight (map: Map | null) {
  removeLayerFrom(map, LAYERS.dayNightLayer.config.id)
}

export function removeDepth (map: Map | null) {
  removeLayerFrom(map, LAYERS.depthLayer.config.id)
}
